import { TypeSlug } from 'types/ElementDynamicOptionProps';
import InputsCarrosselBanner from './Forms/InputsCarrosselBanner';
import InputsBannersWithDescription from './Forms/InputsBannersWithDescription';
import InputsDescriptionText from './Forms/InputsDescriptionText';
import InputsFeaturedFilter from './Forms/InputsFeaturedFilter';
import InputsFocusText from './Forms/InputsFocusText';
import InputsGridOfBanners from './Forms/InputsGridOfBanners';
import InputsVerticalRedirectableLinks from './Forms/InputsVerticalRedirectableLinks';
import InputsSingleBanner from './Forms/InputsSingleBanner';
import InputsMediaYoutube from './Forms/InputsMediaYoutube';
import InputsProductGrid from './Forms/InputsProductGrid';
import InputsPopUp from './Forms/InputsPopUp';
import InputsRedirectableLinks from './Forms/InputsRedirectableLinks';
import InputsTitleWithRedirect from './Forms/InputsTitleWithRedirect';
import InputsSingleProduct from './Forms/InputsSingleProduct';
import InputsProductCarousel from './Forms/InputsProductCarousel';
import InputsStoriesCarousel from './Forms/InputsStoriesCarousel';
import InputsHighlightBar from './Forms/InputsHighlightBar';

export function returnTitle(slug: TypeSlug) {
	switch (slug) {
		case 'banner-carousel':
			return 'titleForms.bannersCarousel';

		case 'description-text':
			return 'titleForms.descriptionText';

		case 'featured-filter':
			return 'titleForms.highligthFilter';

		case 'focus-text':
			return 'titleForms.focusText';

		case 'grid-of-banners':
			return 'titleForms.bannersGrid';

		case 'vertical-redirectable-links':
			return 'titleForms.verticalLinksRedirectable';

		case 'product-grid':
			return 'titleForms.productsGrid';

		case 'single-banner':
			return 'titleForms.uniqueBanner';

		case 'media-youtube':
			return 'titleForms.youtubeMedia';

		case 'product-table':
			return 'titleForms.productsTable';

		case 'popup':
			return 'PopUp';

		case 'redirectable-links':
			return 'titleForms.redirectableLinks';

		case 'title-with-redirect':
			return 'titleForms.titleWithRedirect';

		case 'single-product':
			return 'titleForms.uniqueProduct';

		case 'product-carousel':
			return 'titleForms.productsCarousel';

		case 'stories-carousel':
			return 'titleForms.storiesCarousel';

		case 'highlight-bar':
			return 'titleForms.highlightBar';

		case 'banners-with-description':
			return 'titleForms.descriptionBanners';

		default:
			return 'titleForms.dynamicPage';
	}
}

export function returnFormBySlug(slug: TypeSlug) {
	switch (slug) {
		case 'banners-with-description':
			return <InputsBannersWithDescription />;

		case 'banner-carousel':
			return <InputsCarrosselBanner />;

		case 'description-text':
			return <InputsDescriptionText />;

		case 'featured-filter':
			return <InputsFeaturedFilter />;

		case 'focus-text':
			return <InputsFocusText />;

		case 'grid-of-banners':
			return <InputsGridOfBanners />;

		case 'vertical-redirectable-links':
			return <InputsVerticalRedirectableLinks />;

		case 'product-grid':
			return <InputsProductGrid />;

		case 'single-banner':
			return <InputsSingleBanner />;

		case 'media-youtube':
			return <InputsMediaYoutube />;

		case 'popup':
			return <InputsPopUp />;

		case 'redirectable-links':
			return <InputsRedirectableLinks />;

		case 'title-with-redirect':
			return <InputsTitleWithRedirect />;

		case 'single-product':
			return <InputsSingleProduct />;

		case 'product-carousel':
			return <InputsProductCarousel />;

		case 'stories-carousel':
			return <InputsStoriesCarousel />;

		case 'highlight-bar':
			return <InputsHighlightBar />;

		default:
			return <p>Erro no tipo do módulo, contatar equipe Mondelez.</p>;
	}
}
